import React, { ChangeEvent } from 'react';
import Input from 'antd/es/input';
import TextArea from 'antd/es/input/TextArea';

import { BaseInputProps, DescriptionFormItem } from './shared';

interface TextInputProps extends BaseInputProps {
    onChange?: (val: ChangeEvent<HTMLInputElement>) => void;
    value?: string;
}
export const TextInput = ({
    label,
    name,
    rules,
    description = '',
    placeholder,
    onChange,
    hidden = false,
    value,
}: TextInputProps) => {
    return (
        <DescriptionFormItem
            label={label}
            name={name}
            rules={rules}
            description={description}
            hidden={hidden}>
            <Input placeholder={placeholder} onChange={onChange} value={value} />
        </DescriptionFormItem>
    );
};

interface TextAreaInputProps extends BaseInputProps {
    rows?: number;
}
export const TextAreaInput = ({
    label,
    name,
    rules,
    description = '',
    placeholder,
    rows,
}: TextAreaInputProps) => {
    return (
        <DescriptionFormItem label={label} name={name} rules={rules} description={description}>
            <TextArea rows={rows || 6} placeholder={placeholder} />
        </DescriptionFormItem>
    );
};
